import { useEffect } from "react";
import StatsigService from "@/services/statsigService";

const useInitApp = () => {
  useEffect(() => {
    StatsigService.initialize();
  }, []);

  return {};
};

export default useInitApp;
